import { useEffect } from "react";
import Nav from "./nav/Nav";
import Sidenav from "./nav/Sidenav";
import Footer from "./Footer";

const Layout = ({children}) => {

    useEffect(() => {
        // var height = $('.top-nav').height();
        // // $('.fixed-action-btn').addClass('hide');
        // height += 30
        // window.addEventListener('scroll', () => {
        //     if(window.scrollY > height) {
        //         $('.nav').addClass('fixed');
        //         // $('.fixed-action-btn').addClass('make-visible');
        //     } else {
        //         $('.nav').removeClass('fixed');
        //         // $('.fixed-action-btn').removeClass('make-visible');
        //     }
        //     //console.log(window.scrollY);
        // },{ passive: true });
        // window.addEventListener('resize', () => {
        //     height = $('.top-nav').height();
        // },{ passive: true });
    }, []);

    return ( 
        <>
            <Nav />
            <Sidenav />
            <div className="layout-wrapper">
                { children }
            </div>
            <Footer />
        </>
     );
}
 
export default Layout;